import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useStyles = makeStyles((theme: Theme) => ({
  containerHeader: {
    paddingTop: 5.8,
    paddingBottom: 5.8,
    backgroundColor: '#2c3940',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerLeftButtonsNavHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 20.5,
  },
  containerRightButtonsNavHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    right: 29,
  },
  containerTitleResourceCenter: {
    width: 261,
    height: 71.33,
    marginLeft: 150.78,
    marginRight: 150.78,
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      height: 'auto',
      aspectRatio: 261 / 71.33,
    },
  },
  titleResourceCenter: {
    width: 261,
    height: 71.33,
    borderRadius: 6,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: 'auto',
      aspectRatio: 261 / 71.33,
    },
  },
  locationIcon: {
    width: 30.6,
    height: 30.6,
  },
  titleLocation: {
    fontFamily: 'Roboto',
    fontSize: 15,
    lineHeight: 2.73,
    letterSpacing: 0.15,
    textAlign: 'center',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  chevronDownIcon: {
    width: 13.8,
    height: 8.2,
    marginLeft: 6.6,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  searchIcon: {
    width: 22.3,
    height: 22.3,
  },
  searchButton: {
    padding: 0,
    backgroundColor: 'transparent',
    width: 22.3,
    height: 22.3,
    marginTop: 0,
    marginRight: 21.5,
  },
  flagButton: {
    padding: 0,
    backgroundColor: 'transparent',
    width: 14.8,
    height: 19.7,
    marginTop: 0,
    marginRight: 30.2,
  },
  flagIcon: {
    width: 14.8,
    height: 19.7,
  },
  buttonAddResource: {
    width: 162,
    height: 41,
    marginTop: 0,
    paddingTop: 10,
    paddingRight: 24,
    paddingLeft: 25,
    paddingBottom: 10,
    borderRadius: 8,
    backgroundColor: '#35a0d9',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  titleButtonAddResource: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.25,
    textAlign: 'left',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  plusButton: {
    marginTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    backgroundColor: 'transparent',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  plusIcon: {
    width: 16,
    height: 15.12,
  },
  containerContent: {
    paddingTop: 116,
    paddingBottom: 113.9,
    paddingLeft: 144.5,
    paddingRight: 120,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.only('md')]: {
      paddingLeft: 70,
      paddingRight: 70,
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: 35,
      paddingRight: 35,
    },
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: 26,
    fontWeight: 900,
    letterSpacing: 0.25,
    textAlign: 'left',
    color: '#efefef',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  wrapperQuickAccess: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16.1,
    paddingRight: 22,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  titleQuickAccess: {
    opacity: 0.5,
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.16,
    textAlign: 'left',
    color: '#efefef',
    marginTop: 8,
  },
  wrapperQuickAccessButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 8,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  buttonsQuickAccess: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 37,
    marginTop: 0,
    marginLeft: 9.8,
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 17.5,
    paddingRight: 18,
    borderRadius: 18,
    backgroundColor: '#2c3940',
  },
  titleButtonsQuickAccess: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.16,
    textAlign: 'center',
    color: '#35a0d9',
  },
  sortByIcon: {
    width: 10.5,
    height: 6.2,
    marginLeft: 5.6,
  },
  createNewFolderIcon: {
    width: 16,
    height: 15.12,
    marginRight: 10.2,
  },
  divider: {
    height: 1,
    marginBottom: 55.4,
    opacity: 0.4,
    backgroundColor: '#707070',
  },
  containerFolders: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 29.6,
    flexWrap: 'wrap',
  },
  titleAllResources: {
    opacity: 0.5,
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.16,
    textAlign: 'left',
  },
  containerAllResources: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.only('sm')]: {
      justifyContent: 'space-around',
    },
  },
}));
